module.exports = __webpack_public_path__ + "static/media/scanape.8662f18c.jpeg";